import { render, staticRenderFns } from "./DonutChartV2.vue?vue&type=template&id=3b29ca3e&scoped=true&"
import script from "./DonutChartV2.vue?vue&type=script&lang=js&"
export * from "./DonutChartV2.vue?vue&type=script&lang=js&"
import style0 from "./DonutChartV2.vue?vue&type=style&index=0&id=3b29ca3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b29ca3e",
  null
  
)

export default component.exports